import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { customDocumentTypeOptions } from "../../Accounts/requests/postCustomPlanDocument";
import { documentTypeOptions } from "../../Accounts/requests/postPlanDocument";
import { AgreementSignatureTypes, } from "../../Types";
export const ClientDocumentData = z.object({
    path: z.string(),
    agreementTemplate: z.enum([
        ...documentTypeOptions,
        ...customDocumentTypeOptions,
    ]),
    signatureType: z.enum(AgreementSignatureTypes),
});
const url = () => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/custodian-doc/v2/documents/client`
        : `https://middleware.uat.farther.com/custodian-doc/v2/documents/client`;
};
export default async function postUploadClientDocument(clientId, document, documentData, config) {
    const formData = new FormData();
    formData.append("document", document);
    formData.append("documentData", JSON.stringify(documentData));
    await axios.postForm(url(), formData, {
        headers: {
            Client: clientId,
            Authorization: `Bearer ${config.jwt}`,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
}
//# sourceMappingURL=postUploadClientDocument.js.map